module.exports = __webpack_public_path__ + "fonts/优设标题黑.1726685c.ttf";